import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { PaymentStatusProjection } from '@/lib/services/sales-order-payments/sales-order-payments.types'

export interface CartPaymentStatusRequest {
  organizationId: OrganizationId
  cartId?: number | string | null | undefined
  paymentId?: number | string | null | undefined
}

export async function getCartPaymentStatus({
  organizationId,
  cartId,
  paymentId,
}: CartPaymentStatusRequest): Promise<PaymentStatusProjection> {
  return axios.get<PaymentStatusProjection>(
    `/cart/${cartId}/payments/${paymentId}/status`,
    buildAdminRequestConfig({ organizationId })
  )
}
